import * as React from 'react';

import Button from 'components/atoms/v2/Button';
import { ShoppingCartIcon } from 'components/icons';
import GiftBoxSkuSelectModal from 'components/molecules/GiftBoxSkuSelectModal';
import SkuSelectModal from 'components/molecules/SkuSelectModal';
import classes from './CartButton.scss';

type Props = {
  productId: number;
  shouldShowSkuModal: boolean;
  isGiftBox: boolean;
};

const ADD_TO_CART_LABEL = 'カートに入れる';
const SELECT_OPTIONS_LABEL = '色・サイズなどを選択して';

const resolveCsrfToken = (): string => {
  if (typeof document === 'undefined') {
    return '';
  }
  const tokenInput = document.querySelector<HTMLInputElement>('input[name="_csrfToken"]');
  return tokenInput?.value ?? '';
};

const CartButton: React.FC<Props> = ({ productId, shouldShowSkuModal, isGiftBox }) => {
  const csrfToken = resolveCsrfToken();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [giftBoxTriggerElement, setGiftBoxTriggerElement] = React.useState<HTMLButtonElement | null>(null);
  const openModal = React.useCallback(() => setIsModalOpen(true), []);
  const closeModal = React.useCallback(() => setIsModalOpen(false), []);
  const shouldShowGiftBoxModal = shouldShowSkuModal && isGiftBox;
  const giftBoxLabel = (
    <span className={classes['cartButton__giftBoxLabel']}>
      <span>ギフトボックスを</span>
      <span>作成する</span>
    </span>
  );

  if (shouldShowGiftBoxModal) {
    return (
      <>
        <Button
          ref={setGiftBoxTriggerElement}
          size="lg"
          fullWidth
          icon={<ShoppingCartIcon />}
          label={giftBoxLabel}
          className={classes['cartButton--giftBox']}
        />
        {giftBoxTriggerElement ? (
          <GiftBoxSkuSelectModal
            productId={productId}
            isPreview={false}
            preferEGift
            triggerElement={giftBoxTriggerElement}
          />
        ) : null}
      </>
    );
  }

  if (shouldShowSkuModal) {
    return (
      <>
        <Button
          size="lg"
          fullWidth
          icon={<ShoppingCartIcon />}
          label={ADD_TO_CART_LABEL}
          subLabel={SELECT_OPTIONS_LABEL}
          onClick={openModal}
        />
        <SkuSelectModal
          isOpen={isModalOpen}
          onClose={closeModal}
          productId={productId}
          csrfToken={csrfToken}
        />
      </>
    );
  }

  return (
    // prettier-ignore
    <form action="/carts/add" method="post" style={{ width: '100%' }}>
      {csrfToken ? <input type="hidden" name="_csrfToken" value={csrfToken} /> : null}
      <input type="hidden" name="prefer_egift" value="1" />
      <input type="hidden" name="product_id" value={productId} />
      <input type="hidden" name="quantity" value="1" />
      <Button
        type="submit"
        size="lg"
        fullWidth
        icon={<ShoppingCartIcon />}
        label={ADD_TO_CART_LABEL}
        className="gtm-cart-btn"
      />
    </form>
  );
};

export default CartButton;
